import { render, staticRenderFns } from "./Consulenti.vue?vue&type=template&id=21fc4004&scoped=true&"
import script from "./Consulenti.vue?vue&type=script&lang=js&"
export * from "./Consulenti.vue?vue&type=script&lang=js&"
import style0 from "./Consulenti.vue?vue&type=style&index=0&id=21fc4004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fc4004",
  null
  
)

export default component.exports